import React,{ useState   }  from 'react';
import { Strophe, $iq, $pres, $build } from 'strophe.js';
import {animateScroll} from 'react-scroll';
import * as api from '../api';
import '../strophejs-plugin-register';
import Text from './Text';
import Languages from './Languages';
import VerticalMenu from './VerticalMenu';
import TextBtn from './TextBtn';
import BlueChat from './BlueChat';
import BlockNumber from './BlockNumber';
import MessageSent from './MessageSent';
import CheckList from './CheckList';
import Feedback from './Feedback';
import Support from './Support';
import BCheck from './BCheck';
import AppList from './AppList';
import SliderDetails from './SliderDetails';
import Balance from './Balance';
import Radios from './Radios';
import Options from './Options';
import HorizontalMenu from './HorizontalMenu';
import Checkboxes from './CheckBoxes';
import  ChatbotSvg  from  "../../../_assets/sass/pages/chatbot/logochat.png";
import  closeImg  from  "../../../_assets/sass/pages/chatbot/close.svg";
import  StarSvg  from  "../../../_assets/sass/pages/chatbot/star.svg";
import { KTCookie } from   "../../../_assets/js/components/cookie";
import { injectIntl } from "react-intl"; 
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import {
  sendRequestDotNet
} from "../../../../_utils/Axios"   
//const ltx = require('ltx');
class XMPP extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.optionsRef = React.createRef(); 
        
        this.state = {
            jid: 'a5cf4b28-3a31-4e22-8b2f-c35ed18f1398@korekchat.devapp.co',
            password: 'ZGqEdmvNI57pcmzfXu7tXzYy9OGL17Odb9alwv5zZLI9v6bmpM',
            nickname: '',
            page:0,
            registerPageShow: false,
            registrationName: '',
            registrationPassword: '',
            registrationPasswordConfirm: '',
            registrationStatus: '',
            friendToAdd: '',
            friendRequest: '',
            connectionStatus: 'Not Connected',
            connected: false,
            messages: [],
            message : '',
            recipient: 'bot_admin@korekchat.devapp.co',
            server:'https://korekchat.devapp.co:7443/http-bind/',
          // recipient: 'bot_supportcenter@ofchat.inmobiles.net',
          // recipient: '74b3f93f-6b86-4b3a-bcd1-9ca17843561d@ofchat.inmobiles.net',
            onlineFriends: [],
            chatRooms: [],
            chatType: 'chat',
            roomParticipants: [],
            userType:'1',
            lang:'1',
            did:'b5b62a2e-2bbc-4b57-aafb-98b12712e481',
            mtype:'cinit',
            showOptions: false,
            isScreenDisabled:false,
            chatVisible:false,
            response:{},
            initResponse:{},
            objectType:-1,
            messageSent:{},
            typeId:null,
            msisdn:'',
            isMsisdnInvalid:false,
            isFeedbackInvalid:false,
            isSubjectInvalid:false,
            subject:'',
            feedback:"",
            isBlockButtonDisabled: false,
            isFeedbackButtonDisabled:false
        };

        this.onStatusChange = this.onStatusChange.bind(this);
        this.getNewMessage = this.getNewMessage.bind(this);
        this.generateUniqueMessageId = this.generateUniqueMessageId.bind(this);
        this.messageHandleChange = this.messageHandleChange.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.toggleOptions = this.toggleOptions.bind(this);
        this.blockNumber = this.blockNumber.bind(this);
        this.unblockNumber = this.unblockNumber.bind(this);
        this.handleMsisdnChange  = this.handleMsisdnChange.bind(this);
        this.subjectChange  = this.subjectChange.bind(this);
        this.feedbackChange  = this.feedbackChange.bind(this);
        this.submitFeedback = this.submitFeedback.bind(this);
        }
    menuOptions = [
        "I need help with something", 
        "I have a problem", 
        "Something's not working", 
        "I didn't get my service",
        "I can't find what I'm looking for"
    ];
     menuOptions1 = [
        "All", 
        "Today", 
        "Last Week", 
        "Last month",
        "Last 3 months"
    ];
    
    width = {width: this.props.width? this.props.width : '400px'};
    height = {height: this.props.height? this.props.height: '400px'};
    mainColor = {
        backgroundColor: this.props.mainColor,
        color: this.props.textColor
    }
    secondaryColor = {
        backgroundColor: this.props.secondaryColor
    }

    toggleChat = (event) => {
        event.stopPropagation(); 
        this.setState((prevState) => ({
            chatVisible: !prevState.chatVisible 
        }));
    }
    handleMsisdnChange = (e) => {
        const inputValue = e.target.value;
        // Use a regular expression to remove any non-digit characters
        const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
        this.setState({ msisdn: sanitizedValue ,isMsisdnInvalid: false});
    };
    subjectChange = (e) => {
        this.setState({ subject: e.target.value});
    };
    feedbackChange = (e) => {
        this.setState({ feedback: e.target.value});
    };
    blockNumber = async () =>{
       const msisdn = this.state.msisdn;
       const numberRegex = /^\d+$/;
       const validPrefixes = ['964751', '964750', '0751', '0750'];
       const hasValidPrefix = validPrefixes.some(prefix => msisdn.startsWith(prefix));

        // For '961751' and '961750' (6 digits), the total length should be 6 + 7 = 13.
        // For '0751' and '0750' (4 digits), the total length should be 4 + 7 = 11.
        const isValidLength = 
            (msisdn.startsWith('964751') || msisdn.startsWith('964750')) && msisdn.length === 13 ||
            (msisdn.startsWith('0751') || msisdn.startsWith('0750')) && msisdn.length === 11;

        // Final validation check
        if (!hasValidPrefix || !isValidLength) {
            this.setState({ isMsisdnInvalid: true });
            return;
        }
        let params={
        "type":this.state.objectType,
        "typeId":1, 
        "msisdn": this.state.msisdn
        };
		 this.setState({ isBlockButtonDisabled: true }); 
		try {
        const response = await sendRequestDotNet("Chat/getBotResponse", params, {});
        this.setState({ msisdn: "" });
        return response;
        } catch (error) {
            this.setState({ isBlockButtonDisabled: false }); 
            console.error("Feedback submission failed", error);
            return error;
        }
    }
     componentWillUnmount() {
        this._isMounted = false;
    }

    unblockNumber = async (type,typeid,number)=>{
       
        let params={
        "type":type,
        "typeId":3, 
        "msisdn": number
       };
       
        try {
        const response = await sendRequestDotNet("Chat/getBotResponse", params, {});
        return response;
        } catch (error) {
            console.error("Feedback submission failed", error);
            return error;
        }
    }
    


    submitFeedback = async ()=>{
       const {subject,feedback} = this.state;
       let isInvalid = false;

        if (feedback.length === 0) {
            this.setState({isFeedbackInvalid: true});
            isInvalid = true;
        } else {
            this.setState({isFeedbackInvalid: false});
        }

        if (subject.length === 0) {
            this.setState({isSubjectInvalid: true});
            isInvalid = true;
        } else {
            this.setState({isSubjectInvalid: false});
        }

        if (isInvalid) {
            return;
        }
      

       let params={
        "type":10,
        "subject":subject, 
        "message": feedback
       };
       this.setState({ isFeedbackButtonDisabled:true });
       try {
        const response = await sendRequestDotNet("Chat/getBotResponse", params, {});
        this.setState({ subject: "", feedback: ""});
        return response;
        } catch (error) {
            console.error("Feedback submission failed", error);
            this.setState({ isFeedbackButtonDisabled:false });
            return error;
        }
    }

     sendNewMsg = (type,typeid,msisdn) => {
       this.setState({isFeedbackButtonDisabled: false ,isBlockButtonDisabled: false ,objectType:type,showOptions:false,typeId:typeid,response:{}});
       let params={
        "type":type,
        "typeId": (typeof typeid === 'string' && typeid.includes('_')) ? typeid.split('_')[0] : typeid,
        "msisdn": msisdn
       };
       if((typeid != 1 &&  type!=10)  || (type!=1  && type!=10)){
       sendRequestDotNet("Chat/getBotResponse", params, {}).then((response) => {
        const botResponse =  response?.response || response?.data.response;
        console.log('botResponse', botResponse);
        if (botResponse) {
            const responseArray = Array.isArray(botResponse) ? botResponse : [botResponse];
            this.setState({'response': responseArray});
        }
       });
       }
        let messageData;let icon = '';
        if (typeid !== null) {
            if(type==8)
            messageData = typeid === 1 ? "Block Number" : "Check List";
           else if(type==5)
            messageData = typeid.split('_')[1];
            icon = typeof typeid === 'string' && typeid.split('_').length === 3 ? typeid.split('_')[2] : "";
        } else {
            messageData = this.state.initResponse ? this.state.initResponse.availableTypes.find(item => item.id === type).title : "";
            icon = this.state.initResponse ? this.state.initResponse.availableTypes.find(item => item.id === type).icon : "";
        }
        
        const messageSent = {
            id:typeid !== null ? typeid : type,
            data:messageData,
            time:this.state.initResponse.initMessage.time,
            icon: icon
        }
        this.setState({'messageSent':messageSent});
        if (this.optionsRef.current) {
          this.optionsRef.current.hideOptions();
        }
    }

    hideChat = (event) => {
        event.stopPropagation();  
        this.setState({ chatVisible: false });
    }
   
    toggleOptions = () => {
        this.setState(prevState => ({
            showOptions: true
        }));
    }
    incrementPage = (index) => {
        this.setState({ chatVisible: true });
        if(index==0){
        this.setState((prevState) => ({ page: prevState.page + 1 }));
        }
        else if(index > 0){
        this.setState({ page: 3 });
        }
        else  {
        this.setState({ page:  2 });
        }
        
    };
    componentDidUpdate(prevState) {
        const isConnected = localStorage.getItem("openFireUser");
        if (this.state.page === 2 && prevState.page !== 2 && !isConnected) {
            const created_profile = localStorage.getItem("response_openfireprofile");
            if (!created_profile) {
                this.connect();
            } else {
            let data =  JSON.parse(created_profile);
            const { openFireUser, openFirePass,xmppDomain ,botId } = data.chatInfo;
            this.setState({ jid: openFireUser+'@'+xmppDomain, password: openFirePass ,server:'https://'+xmppDomain+':5244/http-bind/',recipient:botId+'@'+xmppDomain }, () => {
                
                // if (storedMessages) {
                //     const messages = JSON.parse(storedMessages);
                //     this.setState({ messages:messages }); 
                // }
                this.connect();
            });
            }
        }
    }

  loadInitChat() {
    sendRequestDotNet("Chat/LoadData", {}, {})
      .then((response) => {
          if (response.data.statusCode.code === 0) {
            this.setState({ 'initResponse': response.data });
          }
      });
  }
    
    // useEffect(() => {
    //  loadInitChat();
    // }, []); 

   componentDidMount() {
       this._isMounted = true;
       this.loadInitChat();
     }
    // componentDidMount() {
    //     const created_profile = localStorage.getItem("response_openfireprofile");
       
    //     if(!created_profile){
    //        //this.createOpenfireProfile();

    //       // const storedMessages = localStorage.getItem("openFireUser_" + this.state.jid);
           
    //     //    if (storedMessages) {
    //     //     const messages = JSON.parse(storedMessages);
    //     //     this.setState({ messages:messages }); 
    //     //    }
    //        //this.connect();
    //     }
    //     else{
           
    //         let data =  JSON.parse(created_profile);
    //         const { openFireUser, openFirePass,xmppDomain ,botId } = data.chatInfo;
    //         this.setState({ jid: openFireUser+'@'+xmppDomain, password: openFirePass ,server:'https://'+xmppDomain+':5244/http-bind/',recipient:botId+'@'+xmppDomain }, () => {
    //             // const storedMessages = localStorage.getItem("openFireUser_" + this.state.jid);
    //             // if (storedMessages) {
    //             //     const messages = JSON.parse(storedMessages);
    //             //     this.setState({ messages:messages }); 
    //             // }
    //             this.connect();
    //         });
    //     }
        
    // }

    createOpenfireProfile() {
        api.postOpenfireProfile().then(data => {
           console.log("data",data);
           if (data.chatInfo!=null && data.chatInfo.openFireUser!=null) {
            localStorage.setItem("response_openfireprofile", JSON.stringify(data));
            const { openFireUser, openFirePass,xmppDomain ,botId } = data.chatInfo;
            this.setState({ jid: openFireUser+'@'+xmppDomain, password: openFirePass ,server:'https://'+xmppDomain+':7443/http-bind/',recipient:botId+'@'+xmppDomain }, () => {
            this.connect();
            });
        } else {
            this.onStatusChange('Error creating Openfire profile:', data.statusCode.message);
        }
        }).catch(e => {
            console.log("e", e);
        });

    }

  
    connect() {
        this.connection = new Strophe.Connection(this.state.server, "KEEPALIVE");
        this.connection.connect(this.state.jid, this.state.password, this.onConnect);
    }

    onConnect = (status) =>{
        localStorage.setItem("openFireUser",1);
        if(status === Strophe.Status.CONNECTING){
            this.onStatusChange("Connecting");
        }
        else if(status === Strophe.Status.CONNFAIL){
            this.onStatusChange("Connection Failed, retrying.");
        }
        else if(status === Strophe.Status.DISCONNECTING){
            this.onStatusChange("Disconnecting");
        }
        else if(status === Strophe.Status.DISCONNECTED){
            this.onStatusChange("Disconnected");
        }
        else if(status === Strophe.Status.AUTHENTICATING){
            this.onStatusChange("Authenticating.");
        }
        else if(status === Strophe.Status.AUTHFAIL){
            this.onStatusChange("Incorrect username or password.");
            this.connection = new this.Strophe.Strophe.Connection(this.state.server, "KEEPALIVE");

        }
        else if(status === Strophe.Status.CONNECTED){
            this.onStatusChange("Connected!");
            this.setState({connected : true})
            this.connection.addHandler(this.onMessage, null, 'message', null, null, null);
            this.connection.addHandler(this.onSubscriptionRequest, null, 'presence', 'subscribe');
            this.connection.addHandler(this.onPresence, null, 'presence');
            this.getRoster();
            this.listRooms();
            //this.sendAllPendingMessages();
            const storedMessages = localStorage.getItem("openFireUser_" + this.state.jid);
            if (!storedMessages) {
                this.sendMessage(this.state.recipient, this.state.message);
            }
        }
        else{
            this.onStatusChange("Unable to connect.");
            this.connection = new Strophe.Connection(this.state.server, "KEEPALIVE");
        }
    }
    sendAllPendingMessages = () =>{
        if(this.state.messages.length >0){
        let updatedMessages = this.state.messages.map(msg => {
            if (msg.msgs[0].status === 1) {
                msg.msgs[0].status = 2; 
            }
            return msg;
        });
        this.setState({ messages: updatedMessages }, this.scrollToBottom);
        localStorage.setItem("openFireUser_"+this.state.jid, JSON.stringify(updatedMessages));
       }
    }

    listRooms = () =>{
        this.connection.send(this.Strophe.$pres());
        let iq = this.Strophe.$iq({
            from: this.state.jid,
            to: this.props.MUC,
            type: 'get'
        }).c('query',{
            xmlns: 'http://jabber.org/protocol/disco#items'
        });
        this.connection.sendIQ(iq, this.listRoomCallback);
    }
    onStatusChange = (status) =>{
        this.setState({connectionStatus: status});
    }
    onSubscriptionRequest = (stanza) =>{
        if(stanza.getAttribute('type') === 'subscribe'){
            let from = stanza.getAttribute('from');
            this.connection.send(this.Strophe.$pres({
                to: from,
                type: 'subscribed'
            }))
            this.setState({friendRequest : from});
        }
        return true;
    }

    onPresence = (presence) =>{
        let from = presence.getAttribute('from');
        if(this.props.MUC && from && from.includes(this.props.MUC)){
            let nick = from.substring(from.indexOf('/') + 1, from.length);
            let roomParticipantsNew = this.state.roomParticipants;
            if(!roomParticipantsNew.includes(nick)){
                roomParticipantsNew.push(nick);
                this.setState({roomParticipants : roomParticipantsNew});
            }
        }
        if(from.includes('/') && !from.includes(this.state.jid) && !from.includes(this.props.MUC)){
            let nick = from.substring(0, from.indexOf('@'));
            let onlineFriendsNew = this.state.onlineFriends;
            let alreadyInList = false;
            for(let i = 0; i < this.state.onlineFriends.length; i++){
                if(this.state.onlineFriends[i].name === nick){
                    alreadyInList = true;
                }
            }
            if(!alreadyInList){
                onlineFriendsNew.push( {name: nick, jid : from});
                this.setState({onlineFriends : onlineFriendsNew});
            }
        }
        return true;
    }

    onMessage = (message) =>{
        console.log('Received Raw XML:', Strophe.serialize(message));
        this.connection.rawOutput = (data) => console.log("Received Raw output:", data);
        let to = message.getAttribute('to');
        let from = message.getAttribute('from');
        let type = message.getAttribute('type');
        let receivedId = '';
        try {
            let receivedTags = message.getElementsByTagName('received');
            if (receivedTags.length > 0) {
                receivedId = receivedTags[0].getAttribute('id');
            }
            } catch{}
        let elems = message.getElementsByTagName('body');
        let body = Strophe.getText(elems[0]);
      
       
        if(body != null){
            let name;
            if(type === 'groupchat'){
                name = from.substring(from.indexOf('/') + 1, from.length) ;
            }
            if(type === 'chat'){
                name = from.substring(0, from.indexOf('@')) ;
            }
           
            from = from.substring(0, from.indexOf('/'));
           
            this.getNewMessage(message,false,'',receivedId);
        }
        else if(receivedId && this.state.messages.length > 0){
            let updatedMessages = this.state.messages.map(msg => {
                if (msg.msgs[0].id === receivedId) {
                    msg.msgs[0].status = 3; 
                }
                return msg;
            });
            this.setState({ messages: updatedMessages }, this.scrollToBottom);
            localStorage.setItem("openFireUser_"+this.state.jid, JSON.stringify(updatedMessages));
            
        }
        return true;
    }

    

    getRoster = () =>{
        let iq = this.Strophe.$iq({
            type: 'get'
        }).c('query',{
            xmlns: 'jabber:iq:roster'
        });
        this.connection.sendIQ(iq);
    }

    sendMessage = (to, message) =>{
            this.setState({isScreenDisabled : true});
            setTimeout(() => {
            this.setState({ isScreenDisabled: false });
            }, 10000); 
            const generated_id = this.generateUniqueMessageId();    
            const msg = this.Strophe
            .$build('message', {
                'to':to,
                'from':this.state.jid,
                'type':this.state.chatType,
                'xmlns': 'jabber:client',
                'id':generated_id
            })
            .c('body', {
                did: this.state.did,  
                idusertype: this.state.userType,  
                lang: this.state.lang, 
                isap: '1', 
                mtype: (message ? 'qna' : 'cinit'),
                ft: '0'
            })
            .t(message ? message : '{}').up()
            .c('x', { xmlns: 'urn:xmpp:messageextension/file' })
            .c('profile_name').up()
            .c('file_type').t('Text').up()
            .c('profile_number').t('964').up().up()  
            .c('request', { xmlns: 'urn:xmpp:receipts' });

            console.log("msg",msg);
            this.connection.send(msg);

            //let selfMessage = {
            //   to: to,
            //    from: this.state.jid,
            //    type: this.state.chatType,
            //    name: this.state.jid.substring(0, this.state.jid.indexOf('@')),
            //    message: message
            //}
            if(message)
            this.getNewMessage(message,true,generated_id,'');
            this.setState({message : ''});
            this.scrollToBottom();
    }

    getNewMessage = (message,isme,generated_id,receivedId) =>{
        try{
        //console.log('Raw XML:', this.Strophe.Strophe.serialize(message));
        }
        catch{}
        let type = 1; // 1:text  //2:btns
        let jsonData;
        let now = new Date();
        let year = now.getFullYear();
        let month = String(now.getMonth() + 1).padStart(2, '0'); 
        let day = String(now.getDate()).padStart(2, '0');
        let hours = String(now.getHours()).padStart(2, '0');
        let minutes = String(now.getMinutes()).padStart(2, '0');
        let date = `${year}-${month}-${day} ${hours}:${minutes}`;

       try{
        let  bodies = message.getElementsByTagName('body');
        if (bodies.length > 0) {
            let firstBody = bodies[0];
            let jsonString = firstBody.textContent; 
            try {
                jsonData = JSON.parse(jsonString); 
                date = jsonData.time;
                type = 2; 
                if (jsonData.hasOwnProperty('inputtype')) {
                    type = jsonData.inputtype;
                }
            } catch (error) {
                jsonData  = jsonString;
            }
        }
       }catch{}
       

        let ms = {
            day:date.split(' ')[0] ,
            msgs:[{
                id:generated_id,
                isMe:isme,
                type: type,
                daytime:date,
                data: (jsonData ? jsonData : message),
                status:(this.state.connectionStatus === 'Connected!' ? 2 : 1) // 1:pending -2:-sent 3 :delivered
            }]
        };

        // Check for the receivedId in the current state messages and update its status to 3 (delivered) if found
        if (receivedId) {
            let updatedMessages = this.state.messages.map(msg => {
                if (msg.msgs[0].id === receivedId) {
                    msg.msgs[0].status = 3; 
                }
                return msg;
            });

           
            updatedMessages = updatedMessages.concat(ms);
            this.setState({ messages: updatedMessages }, this.scrollToBottom);
            localStorage.setItem("openFireUser_"+this.state.jid, JSON.stringify(updatedMessages));
        } else {
  
            let newMessages = this.state.messages.concat(ms);
            this.setState({ messages: newMessages }, this.scrollToBottom);
            localStorage.setItem("openFireUser_"+this.state.jid, JSON.stringify(newMessages));
        }
        this.scrollToBottom();
    }

    setRecipient = (friend, chatType) =>{
        this.setState({
            recipient: friend,
            chatType: chatType
        });
    }
  
    handleBackClick = () => {
     this.setState(
        (prevState) => {
            const newPage = (prevState.page === 3 || prevState.page === 0) ? 0 : prevState.page - 1;
            let newShowOptions;
            if (newPage === 0) {
                // Condition 1: If the new page is 0, set to false
                newShowOptions = false;
            } else if (prevState.page === 3 && prevState.showOptions === true) {
                // Condition 2: If the old page was 3 and options were shown, set to false
                newShowOptions = false;
            } else {
                // Otherwise, set to true
                newShowOptions = true;
            }

            return {
                showOptions: newShowOptions,
                page: newPage
            };
        },
        () => {
            if (this.state.page === 0) {
                this.loadInitChat();
            }
            if (this.optionsRef.current) {
                if (this.state.showOptions) {
                    this.optionsRef.current.showOpt();
                } else {
                    this.optionsRef.current.hideOptions();
                }
            }
        }
        );
    };

    messageHandleChange = (e) =>{
        this.setState({message : e.target.value });
    }
    handleKeyPress = (event) => {
        if(event.key === 'Enter'){
          this.sendMessage(this.state.recipient, this.state.message);
          this.setState({message: ''});
        }
    }

    generateUniqueMessageId = () => {
        const currentTime = new Date();
        const formattedTime = currentTime.toISOString().replace(/[-:.]/g, "").slice(0, 15); // YYYYMMDDHHMMSS
        const uniqueId = crypto.randomUUID(); 
        return `${formattedTime}`;
    };


    scrollToBottom() {
        animateScroll.scrollToBottom({
        containerId: "messages"
        });
        
    }

    decodeMessage(message) {
        return message.replace(/&gt;/g, '>').replace(/&quot;/g, '"'); 
    }

    render() {
    const { intl } = this.props;
    let uniqueDays = this.state.messages.reduce((acc, curr) => {
        if (!acc.includes(curr.day)) {
            acc.push(curr.day);
        }
        return acc;
    }, []);
    return (
        <div className="cb_bot_main_circle">
        <div className="cb_bot_span_wrapper" onClick={this.toggleChat}>
            <img src={ChatbotSvg} width="50px;" />
        </div>
      <div className={`cb_bot_main_chat page${this.state.page} ${this.state.chatVisible==true ? 'show' : ''}`}>
    <div className="cb_bot_main_chat_close_button" onClick={(event) => this.hideChat(event)}><i className='fa fa-times'></i></div>
        <div className="container" style={this.width}>
           
            <div>
            
            <div className={`chat-window  ${this.state.showOptions == true  || this.state.page ==  3 ? 'fitall' : ''}`} style={this.mainColor}>

                <div className="chat-area" style={this.mainColor}>
                    {this.state.page === 0 && !this.state.showOptions ? (
                            <div className="head-chat">
                                <img src={ChatbotSvg} width="30px" alt="Chatbot Icon" /> {intl.formatMessage({ id: "CHAT.WITHKOREK" })}
                                <span className="status">Online</span>
                            </div>
                        ) : this.state.page === 3 ? (
                            <div className="head-chat">
                                 <i className="fa fa-arrow-left" onClick={this.handleBackClick}></i><img src={ChatbotSvg} width="30px" alt="Chatbot Icon" />  {intl.formatMessage({ id: "CHAT.HELP" })}
                                 <span className="status">Online</span>
                            </div>
                        ) : (
                            <div className="head-chat">
                                <i className="fa fa-arrow-left" onClick={this.handleBackClick}></i><img src={ChatbotSvg} width="30px" alt="Chatbot Icon" />  {this.state.page === 3 ? intl.formatMessage({ id: "CHAT.REC" }): intl.formatMessage({ id: "CHAT.WITHKOREK" })}
                                 <span className="status">Online</span>
                            </div>
                        )}
                        
                      
                        {/* <div id="messages" className={`message-box ${this.state.page === 0 ? 'show' : ''}`} style={this.height}>
                        {uniqueDays.map((day, dayIndex) => (
                            <div key={dayIndex}>
                                <div className="day-header">
                                    <b>{day}</b>
                                </div> 
                                {this.state.messages
                                    .filter((group) => group.day === day)
                                    .map((dayGroup, groupIndex) => (
                                        dayGroup.msgs.map((message, index) => (
                                            message && (
                                                message.type === 2 ? (
                                                    message.data && message.data.answers ? (
                                                        <TextBtn
                                                            key={index}
                                                            msg={message}
                                                            recipient={this.state.recipient}
                                                            sendMessage={this.sendMessage}
                                                        />
                                                    ) : null
                                                ) : message.type === 32  || message.type === 38  ? (
                                                    //  message.type  render  RADIO( 32 ) --> 2 column,       SINGLE_COLUMN_RADIO(38),
                                                    message.data && message.data.answers ? (
                                                                <Radios
                                                                key={index}
                                                                msg={message}
                                                                single={message.type === 38 ? 1 : 0}
                                                                recipient={this.state.recipient}
                                                                sendMessage={this.sendMessage}
                                                                showOptions={this.state.showOptions} 
                                                                toggleOptions={this.toggleOptions}
                                                            />
                                                    ) : null
                                                ) : message.type === 33   ? (
                                                    message.data && message.data.answers ? (
                                                                <Checkboxes
                                                                key={index}
                                                                msg={message}
                                                                recipient={this.state.recipient}
                                                                sendMessage={this.sendMessage}
                                                            />
                                                    ) : null
                                                ) : (
                                                    message.data ? (
                                                        <Text key={index} msg={message} />
                                                    ) : null
                                                )
                                            )
                                        ))
                                    ))}
        </div>
    ))}
                        </div>
                 */}

                        <div 
                                className={`message-box show ${this.state.page === 2 ? 'message02' : ''} ${this.state.page === 3 ? 'message03' : ''}`} 
                                style={this.height}>

                                    {this.state.page === 0 && (
                                       <Options
                                        shouldFade={false}
                                        isMe={false}
                                        isScreenDisabled={this.state.isScreenDisabled}
                                        incrementPage={this.incrementPage}
                                        toggleOptions={this.toggleOptions}
                                        ref={this.optionsRef}
                                        msg={this.state.initResponse}
                                        sendNewMsg = {this.sendNewMsg}
                                        />
                                    )}

                                 {this.state.page === 1 && (
                                        <Languages
                                        incrementPage={this.incrementPage}
                                        />
                                    )}

                                 {this.state.page === 2 && (
                                    this.state.connected === false ? (
                                        <div className="loadcontent">
                                            <div className="load">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 200 200"><radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)"><stop offset="0" stopColor="#3231B5"/><stop offset=".3" stopColor="#3231B5" stop-opacity=".9"/><stop offset=".6" stopColor="#3231B5" stop-opacity=".6"/><stop offset=".8" stopColor="#3231B5" stop-opacity=".3"/><stop offset="1" stopColor="#3231B5" stop-opacity="0"/></radialGradient><circle transform-origin="center" fill="none" stroke="url(#a12)" stroke-width="15" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70"><animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"/></circle><circle transform-origin="center" fill="none" opacity=".2" stroke="#3231B5" stroke-width="15" stroke-linecap="round" cx="100" cy="100" r="70"/></svg>
                                            </div>
                                            {this.state.connectionStatus}
                                        </div>
                                    ) : (
                                        <HorizontalMenu 
                                    items={this.menuOptions}
                                    recipient={this.state.recipient}
                                    sendMessage={this.sendMessage}
                                    />
                                    )
                                )}
                                 
                                
                               
                                {this.state.page === 3 && (
                                    <>


                                    {this.state.messageSent && (
                                        <>
                                            <Options
                                                shouldFade={false}
                                                isScreenDisabled={true}
                                                isMe={true}
                                                incrementPage={this.incrementPage}
                                                toggleOptions={this.toggleOptions}
                                                ref={this.optionsRef}
                                                msg={this.state.initResponse}
                                                sendNewMsg={this.sendNewMsg}
                                            />
                                            <MessageSent
                                                msg={this.state.messageSent}
                                            />
                                        </>
                                    )}
                                    
                                    {/* <VerticalMenu 
                                        items={this.menuOptions1}
                                        recipient={this.state.recipient}
                                        sendMessage={this.sendMessage}
                                    /> <TextBtn 
                                    items={this.menuOptions}
                                    recipient={this.state.recipient}
                                    sendMessage={this.sendMessage}
                                    /> */}
                                   
                                     {this.state.objectType === 1 && (
                                    <Balance
                                        msg={this.state.response}
                                        sendNewMsg = {this.sendNewMsg}
                                    />
                                     )}
                                       {this.state.objectType === 4 && (
                                    <BlueChat
                                       msg={this.state.response}
                                    />
                                     )}
                                      {this.state.objectType === 11 && (
                                    <Support
                                        msg={this.state.response}
                                    />
                                    )}
                                    
                                      {this.state.objectType === 9 && (
                                    <AppList
                                        msg={this.state.response}
                                    />
                                      )} 

                                       {this.state.objectType === 8 && this.state.typeId== null && (
                                        <BCheck
                                            msg={this.state.response}
                                            sendNewMsg = {this.sendNewMsg}
                                        />
                                      )}
                                     {this.state.objectType === 10 && (
                                    <Feedback
                                       onFeedbackChange = {this.feedbackChange}
                                       onSubjectChange = {this.subjectChange}
                                        subject={this.state.subject}
                                        desc={this.state.feedback}
                                        submitFeedback = {this.submitFeedback}
                                        isFeedbackInvalid = {this.state.isFeedbackInvalid}
                                        isSubjectInvalid = {this.state.isSubjectInvalid}
                                        isDisabled={this.state.isFeedbackButtonDisabled} 
                                    />
                                     )}
                                      {this.state.objectType === 5 && !this.state.response.offers && this.state.typeId == null && (
                                    <Options 
                                        isScreenDisabled={this.state.isScreenDisabled}
                                        shouldFade={false}
                                        isMe={false}
                                        incrementPage={this.incrementPage}
                                        toggleOptions={this.toggleOptions}
                                        ref={this.optionsRef}
                                        msg={this.state.response}
                                        sendNewMsg = {this.sendNewMsg}
                                        
                                        />
                                     )}

                                     { (this.state.objectType === 2 || this.state.objectType === 3 || this.state.objectType === 6 || this.state.objectType === 7 || (this.state.objectType == 5 && this.state.typeId !=null ) || (this.state.response  && this.state.response.offers ))  && (
                                        <SliderDetails
                                            msg={this.state.response}
                                        />
                                    )}
                                     {this.state.objectType === 8 && this.state.typeId==1 && (
                                   <BlockNumber
                                        msisdn={this.state.msisdn}
                                        onMsisdnChange={this.handleMsisdnChange}
                                        onBlockClick={this.blockNumber}
                                        isInvalid={this.state.isMsisdnInvalid} 
                                        isDisabled={this.state.isBlockButtonDisabled} 
                                        
                                    />
                                     )}
                                      {this.state.objectType === 8 && this.state.typeId==2 && (
                                     <CheckList
                                        msg={this.state.response}
                                        unblockNumber = {this.unblockNumber}
                                    /> 
                                     )}
                                    </> )}
                              {(
        (this.state.objectType !== -1 && this.state.objectType !== 5 && this.state.page === 3) ||
        (this.state.response.offers  && this.state.page !=0 ) ||
        (this.state.typeId !== null && this.state.page !=0 )
    ) && (                               <Options 
                                        key={this.state.objectType + '-' + this.state.typeId}
                                        isScreenDisabled={this.state.isScreenDisabled}
                                        shouldFade={true}
                                        isMe={false}
                                        incrementPage={this.incrementPage}
                                        toggleOptions={this.toggleOptions}
                                        ref={this.optionsRef}
                                        msg={this.state.initResponse}
                                        sendNewMsg = {this.sendNewMsg}
                                       
                                        />
                               )}
    
                        </div>
                       
                    <div className={`text-area ${this.state.showOptions == true   ? 'hide' : ''}`}>
                        <img src={StarSvg} />
                        <input value={this.state.message} onChange={this.messageHandleChange} onKeyPress={ this.handleKeyPress} ref='messageInput' type="text" placeholder="Ask Anything"></input>
                        <button  onClick={() => {
                            if (this.state.message.trim() !== '' && this.state.page == 2) {
                                this.sendMessage(this.state.recipient, this.state.message);
                            }
                            else {
                               this.setState({
                                    page: this.state.page === 0 ? 1 : 2
                                });
                            }
                            }}>
                         <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
            
            </div>
        </div></div>
        </div>
    );
    }
}

export default injectIntl(XMPP);